/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://s2p5hgp5vzgq5n3p2i7kl3v7b4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-wcbwo2febfavvlwt3v477vfp4q",
    "aws_cloud_logic_custom": [
        {
            "name": "api42e141d2",
            "endpoint": "https://cluxjxp0l4.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        },
        {
            "name": "emailing",
            "endpoint": "https://uwphvxq2o1.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:0e47ee71-7248-4437-a780-156397f0429f",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_sz9WhvbOX",
    "aws_user_pools_web_client_id": "onn01c37b83vl3ln795f912fg",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "specificationsbucket170805-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
